import { motion } from "framer-motion";
import { fadeUp, lineReveal, viewport } from "@/lib/motion";

export const Reveal = ({ children, delay = 0, className = "", as = "div", ...rest }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag className={className} variants={fadeUp} custom={delay} initial="hidden" whileInView="show" viewport={viewport} {...rest}>
      {children}
    </Tag>
  );
};

export const KineticLines = ({ lines, className = "", inView = false, delayOffset = 0 }) => {
  const anim = inView ? { initial: "hidden", whileInView: "show", viewport } : { initial: "hidden", animate: "show" };
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span className="mask-line" key={i}>
          <motion.span style={{ display: "block" }} variants={lineReveal} custom={i + delayOffset} {...anim}>
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const SectionHead = ({ eyebrow, title, lede, align = "split", children, id }) => (
  <div id={id} className={`grid gap-8 mb-14 lg:mb-20 ${align === "split" ? "lg:grid-cols-[1.15fr_.85fr] lg:items-end lg:gap-20" : ""}`}>
    <Reveal>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="display">{title}</h2>
    </Reveal>
    {(lede || children) && (
      <Reveal delay={1}>
        {lede && <p className="lede m-0">{lede}</p>}
        {children}
      </Reveal>
    )}
  </div>
);
